export const LANGUAGE_KEYS = [
  'ar',
  'de',
  'en',
  'es',
  'fr',
  'pt',
  'ru',
  'tr',
  'uk',
] as const;
export const DEFAULT_LANGUAGE_KEY = LANGUAGE_KEYS[1]; // 'de'
export type LanguageKey = (typeof LANGUAGE_KEYS)[number];
export const languageLabels: Partial<Record<LanguageKey, string>> = {
  ar: 'Arabisch - العربية',
  de: 'Deutsch - Deutsch',
  en: 'Englisch - English',
  es: 'Spanisch - Español',
  fr: 'Französisch - Français',
  pt: 'Portugiesisch - Português',
  ru: 'Russisch - Русский',
  tr: 'Türkisch - Türkçe',
  uk: 'Ukrainisch - Українська',
} as const;
export const publishedLanguageLabels: Partial<Record<LanguageKey, string>> = {
    // ar: 'Arabisch - العربية',
    de: 'Deutsch - Deutsch',
    // en: 'Englisch - English',
    // es: 'Spanisch - Español',
    // fr: 'Französisch - Français',
    // pt: 'Portugiesisch - Português',
    ru: 'Russisch - Русский',
    // tr: 'Türkisch - Türkçe',
    uk: 'Ukrainisch - Українська',
  };

/**
 * {de: string, uk: string | null, ...}
 */
export type TranslatableText<RequiredLang extends LanguageKey = 'de'> = {
  [K in RequiredLang]: string;
} & { [K in Exclude<LanguageKey, RequiredLang>]?: string | null };
export type TranslatableTextRuntime =
  | Map<string, string>
  | { [key: string]: string | null | undefined };

export function isLanguageKey(value: string): value is LanguageKey {
  return LANGUAGE_KEYS.includes(value as LanguageKey);
}
export function checkBrowserLanguage(browserLanguage?: string): LanguageKey {
  if (!browserLanguage) return DEFAULT_LANGUAGE_KEY;

  return isLanguageKey(browserLanguage) ? browserLanguage : DEFAULT_LANGUAGE_KEY;
}
export function translateVar(value: TranslatableText<"de"> | undefined, currentLang: string, withDefault: boolean = false): string | undefined | null{
    if(!value) return undefined;
    const lang = checkBrowserLanguage(currentLang);
    if(lang in value && value[lang]) return value[lang];    
    if(withDefault && DEFAULT_LANGUAGE_KEY in value && value[DEFAULT_LANGUAGE_KEY]) return value[DEFAULT_LANGUAGE_KEY];
    return undefined;
}

export function localizeText(
  value: TranslatableText<'de'> | undefined,
  lang: LanguageKey,
  defaultLang: LanguageKey = DEFAULT_LANGUAGE_KEY,
): { value?: string; localized: boolean } {
  
  if (!value) {
    return { value: undefined, localized: false };
  }
  if (value[lang]) {
    return { value: value[lang]!, localized: true };
  }
  if (value[defaultLang]) {
    return { value: value[defaultLang]!, localized: false };
  }
  return { value: undefined, localized: false };
}